"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makePopperStyles = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var makePopperStyles = function makePopperStyles(_ref) {
  var primitives = _ref.primitives,
      tokens = _ref.tokens;
  return {
    MuiPopper: {
      styleOverrides: {
        root: {
          "&.DhigFlyout": {
            background: "transparent",
            "&[class*='MuiTooltip-popper'][data-popper-placement*='top'] [class*='MuiTooltip-arrow']:before": {
              boxShadow: "0px 1px 0px 0px rgba(0, 0, 0, 0.6),0px 1px 0px 0px rgba(0, 0, 0, 0.6) inset,1px 0px 0px 0px rgba(0, 0, 0, 0.6) inset,-1px 0px 0px 0px rgba(0, 0, 0, 0.6) inset"
            },
            "&[class*='MuiTooltip-popper'][data-popper-placement*='top'] [class*='MuiTooltip-arrow']": {
              marginBottom: "".concat(primitives.spacings["0"]),
              bottom: "-14px"
            },
            "&[class*='MuiTooltip-popper'][data-popper-placement*='bottom'] [class*='MuiTooltip-arrow']": {
              top: "-13px",
              marginTop: primitives.spacings["0"]
            },
            "& [class*='MuiTooltip-tooltip']": _objectSpread(_objectSpread({
              background: primitives.colors.primary.white
            }, tokens.effects["elevation-0-popover"]), {}, {
              padding: "".concat(primitives.spacings["3"], " 1px ").concat(primitives.spacings["4"], " 1px"),
              borderRadius: primitives.borderRadii["medium"],
              "& [class*='MuiTooltip-arrow']": {
                fontSize: primitives.spacings["5"]
              },
              "& [class*='MuiTooltip-arrow']:before": _objectSpread({
                backgroundColor: primitives.colors.primary.white
              }, tokens.effects["elevation-0-popover"]),
              "& [class*='MuiPaper-root']": {
                boxShadow: "none"
              },
              "& [class*='MuiMenuItem-root']": {
                padding: "".concat(primitives.spacings["2"], " ").concat(primitives.spacings["4"], " ").concat(primitives.spacings["2"], " ").concat(primitives.spacings["5"]),
                "&:focus": {
                  padding: "".concat(primitives.spacings["2"], " ").concat(primitives.spacings["4"], " ").concat(primitives.spacings["2"], " ").concat(primitives.spacings["5"])
                },
                "& [class*='MuiSvgIcon-root']": {
                  position: "absolute",
                  right: primitives.spacings["3"]
                }
              },
              "& [class*='MuiMenuItem-root']:active": {
                background: tokens.colors["activated-pressed-fill-subtle"].rgb
              }
            })
          },
          '&[class*="MuiAutocomplete-popper"]': {
            '& [class*="MuiPaper-root"]': _objectSpread(_objectSpread({}, tokens.typography["body-copy-medium"]), {}, {
              color: tokens.colors["ink-on-background"].rgb,
              boxShadow: tokens.effects["elevation-0-dropdown"].boxShadow,
              borderRadius: "".concat(primitives.borderRadii.none, " ").concat(primitives.borderRadii.none, " ").concat(primitives.borderRadii.medium, " ").concat(primitives.borderRadii.medium),
              margin: "".concat(primitives.spacings["1"], " ").concat(primitives.spacings["0"]),
              backgroundColor: tokens.colors["fill-elevation-0"].rgb,
              '& [class*="MuiAutocomplete-noOptions"]': {
                color: tokens.colors["ink-on-background"].rgb
              },
              '& [class*="MuiAutocomplete-listbox"]': {
                '& .MuiAutocomplete-option[aria-selected="true"]': {
                  backgroundColor: tokens.colors["activated-fill-subtle"].rgb
                },
                '& [class*="MuiAutocomplete-option"]': {
                  cursor: "pointer",
                  display: "flex",
                  boxSizing: "border-box",
                  alignItems: "center",
                  padding: "10px ".concat(primitives.spacings["3"]),
                  justifyContent: "flex-start",
                  "&.Mui-focused": {
                    backgroundColor: tokens.colors["hover-fill-subtle"].rgb
                  },
                  "&.Mui-focused:active": {
                    backgroundColor: tokens.colors["pressed-fill-subtle"].rgb
                  },
                  '& [class*="DhigCombobox--checkedIcon"]': {
                    position: "absolute",
                    right: primitives.spacings["3"]
                  },
                  '& [class*="MuiCheckbox-root"]': {
                    marginRight: primitives.spacings["2"]
                  }
                },
                "& li": {
                  '[class*="MuiListSubheader-root"]': {
                    borderTop: "".concat(primitives.borderWidths.medium, " solid ").concat(tokens.colors["row-divider"].rgb)
                  },
                  '&:first-of-type [class*="MuiListSubheader-root"]': {
                    borderTop: "none"
                  }
                }
              },
              '& [class*="MuiListSubheader-root"]': {
                backgroundColor: primitives.colors.detail.transparent
              },
              '& [class*="DhigCombobox--addendum"]': _objectSpread(_objectSpread({
                color: tokens.colors["detail-2-transparent"].rgb
              }, tokens.typography["body-copy-small"]), {}, {
                padding: primitives.spacings["3"]
              })
            })
          },
          '&[class*="DhigSplitButton--popper"]': {
            zIndex: 1,
            '& [class*="MuiPaper-root"]': {
              marginTop: primitives.spacings["1"],
              boxShadow: tokens.effects["elevation-0-popover"].boxShadow,
              backgroundColor: tokens.colors["fill-elevation-0"].rgb,
              '& [class*="MuiList-root"]': {
                padding: "".concat(primitives.spacings["3"], " ").concat(primitives.spacings["0"])
              }
            }
          },
          '&[class*="DhigSplitButton--overflow--popper"]': {},
          '&[class*="DhigSplitButton--persistent--popper"]': {
            width: "100%",
            '& [class*="MuiMenuItem-root"].Mui-selected': {
              paddingRight: primitives.spacings["4"],
              backgroundColor: tokens.colors["activated-fill-subtle"].rgb,
              "&:active": {
                backgroundColor: tokens.colors["pressed-fill-subtle"].rgb,
                border: "".concat(primitives.borderWidths.large, " solid ").concat(primitives.colors.detail.transparent)
              }
            }
          },
          '&[class*="DhigSplitButton--persistent--popper--standalone"]': {
            width: "min-content"
          }
        }
      }
    }
  };
};

exports.makePopperStyles = makePopperStyles;